import { render } from "./CheckboxGroup.vue?vue&type=template&id=5c473424"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/CheckboxGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c473424"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c473424', __exports__)) {
    api.reload('5c473424', __exports__)
  }
  
  module.hot.accept("./CheckboxGroup.vue?vue&type=template&id=5c473424", () => {
    api.rerender('5c473424', render)
  })

}


export default __exports__